<div class="clutch-card">
  <div class="content">
    <div class="left">
      <div class="badges-top">
        <span class="badge light-orange">🔥 Fast Moving</span>
        <span class="badge light-yellow">⚡ 15 Min Dispatch</span>
      </div>
      <h2>🚗 Car Stuck? <br>Fix it in <span class="purple">90 mins⚡</span></h2>
      <p class="sub-text">No more waiting. Clutch kits ready near you.</p>
      <div class="badges">
        <!-- <span class="badge blue">⚡ 15 min dispatch</span> -->
        <span class="badge green">🚚 Free delivery</span>
        <span class="badge blue">🛡️ Warranty included</span>
        <div class="orange-main">
          <span class="badge orange">⏳ Only few kits left at JC Road</span>
        </div>
      </div>
      <div class="btn-get-clutch">
        <button class="top-btn" (click)="loadrequest()">⚡ Get Clutch Kit Now</button>
      </div>
      <p class="sub-text bottom-note">1-step order • No part selection needed</p>
    </div>

    <div class="right">
      <div class="image-box"><img src="../../../../assets/images/clutch-kit.webp"></div>
    </div>
  </div>
  <div class="brand-strip-section">
    <div class="brand-header">
      <div>
        <h3>Top Clutch Brands Available Instantly</h3>
        <p>Used by leading garages across India</p>
      </div>
      <span class="verified">✔ Verified Brands</span>
    </div>

  <div class="brand-slider">
  <div class="brand-track-wrapper">
    <div class="brand-track">
      <!-- ORIGINAL -->
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/smr.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/exedy.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/sachs.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/luk.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/valeo.png"></div>

      <!-- DUPLICATE -->
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/smr.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/exedy.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/sachs.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/luk.png"></div>
      <div class="brand-item"><img src="../../../../assets/images/brand-of-home-page/valeo.png"></div>
    </div>
  </div>
</div>
  </div>
</div>

<ng-template #intstantorder></ng-template>